import React from 'react'
import { Chip } from '@mui/material'
import { WorkspacePremium } from '@mui/icons-material'
import { useTranslation } from '../../hooks'

const SkillBiteExpertChip = () => {
  const { t } = useTranslation('skill_bite')

  return (
    <Chip
      label={t('expert_chip')}
      color='primary'
      icon={<WorkspacePremium fontSize='small' />}
      data-test='skill-bite-expert-chip'
    />
  )
}

export default SkillBiteExpertChip
